import { render } from "./Pagination.vue?vue&type=template&id=3ef8619b"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Callum\\Desktop\\k1890584_watkins_callum_code\\mo-books\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__